import { CustomEquipment } from '../types/sharedTypeImpl.ts';

type Props = Pick<CustomEquipment, 'badgeText' | 'badgeColor' | 'displayName'>;


export function CmmBadge({
    displayName,
    badgeText,
    badgeColor,
}: Props) {
    if (!badgeText || !badgeColor) return null;

    const backgroundColor = badgeColor;
    const textColor = getTextColor(backgroundColor);

    return (
        <span
            className='cmm-badge'
            style={{ backgroundColor, color: textColor }}
            title={displayName}
        >
            {badgeText}
        </span>
    );
}

// Decide on a black or white text color based on the background color luminance
function getTextColor(backgroundColor: string): string {
    const channels = [1, 3, 5].map(offset => {
        const channel = parseInt(backgroundColor.slice(offset, offset + 2), 16) / 255;
        const linear = channel <= 0.04045
            ? channel / 12.92
            : ((channel + 0.055) / 1.055) ** 2.4;
        return linear;
    });
    const luminance = channels[0] * 0.2126 + channels[1] * 0.7152 + channels[2] * 0.0722;
    const textColor = luminance > 0.179 ? '#000000' : '#ffffff';
    return textColor;
}
